import React from 'react';
import { ReadyState } from 'react-use-websocket';
import useAudioConfigContext from '../../../AudioConfigContext/useAudioConfigContext';
import useAudioCapture from '../../SessionConnectionContextProvider/Hooks/useAudioCapture';
import useSessionInfoContext from '../../SessionInfoContextProvider/useSessionInfoContext';
import useAudioWebsocketApiConnectionContext from './useAudioWebsocketApiConnectionContext';

export default function AudioCaptureUpdater({ children }: { children: React.ReactNode }) {
  const {
    sendMessage,
    sendJsonMessage, lastJsonMessage, readyState,
  } = useAudioWebsocketApiConnectionContext();
  const audioConfig = useAudioConfigContext();
  const { session } = useSessionInfoContext();
  const [lastAudioBlob, restart] = useAudioCapture(!!session && readyState === ReadyState.OPEN, audioConfig);
  const sessionIdRef = React.useRef<string | null>(session?.id ?? null);

  React.useEffect(() => {
    if (session?.id && sessionIdRef.current && session.id !== sessionIdRef.current && readyState === ReadyState.OPEN) {
      restart();
    }
    sessionIdRef.current = session?.id ?? null;
  }, [session?.id, readyState]);

  React.useEffect(() => {
    if (lastJsonMessage && lastJsonMessage.type) {
      switch (lastJsonMessage.type) {
        case 'restart-audio-stream':
          if (readyState === ReadyState.OPEN) {
            restart();
            sendJsonMessage({
              type: 'clear-webm-audio',
              date: Date.now() * 1e6,
            });
          }
          break;

        default:
          break;
      }
    }
  }, [lastJsonMessage, readyState]);

  React.useEffect(() => {
    if (lastAudioBlob) {
      sendMessage(lastAudioBlob);
    }
  }, [lastAudioBlob]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}
